export default __webpack_public_path__ + "static/media/ovary1.4f143915.jpg";